import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Volunteer_position - Get All (Read)
export const GetAll = createAsyncThunk(
  "masters/volunteer_position/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Volunteer_position}?term=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Volunteer_position - Get (Read)
export const GetSingle = createAsyncThunk(
  "masters/volunteer_position/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.Volunteer_position}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Volunteer_position - Create (Add)
export const Create = createAsyncThunk(
  "masters/volunteer_position/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.Volunteer_position, data);
      console.log(res, 'pppppppppppppppppp');

      if (res.success) {
        return res; // The new volunteer_position object
      }
      // return rejectWithValue(res);
    } catch (error) {
      console.log(error, 'error');

      return rejectWithValue(error.response.data);
    }
  }
);

// Volunteer_position - Update
export const Update = createAsyncThunk(
  "masters/volunteer_position/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Masters.Volunteer_position}/${id}`, data);
      if (res.success) {
        return res; // The new volunteer_position object
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Volunteer_position - Delete
export const Delete = createAsyncThunk(
  "masters/volunteer_position/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Masters.Volunteer_position}/${id}`);
      return id; // Return the id of the deleted volunteer_position
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Volunteer_position - Status
export const StatusVolunteer_position = createAsyncThunk(
  "masters/volunteer_position/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Volunteer_position}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "volunteer_position",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (volunteer_position) => volunteer_position.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (volunteer_position) => volunteer_position.id !== action.payload.id
        ); // Remove the volunteer_position with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(StatusVolunteer_position.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusVolunteer_position.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (volunteer_position) => volunteer_position.id !== action.payload.id
        ); // Remove the volunteer_position with the deleted id
      })
      .addCase(StatusVolunteer_position.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
